export const INTENTIONS = [
  { id: "clarity", label: "I need clarity", symbol: "\u2728", affirmation: "Through the fog, the truth is closer than it feels." },
  { id: "stuck", label: "I feel stuck", symbol: "\u26d3\ufe0f", affirmation: "What feels like a wall may be a door you haven't turned to face yet." },
  { id: "overwhelmed", label: "I feel overwhelmed", symbol: "\u{1F30A}", affirmation: "You do not have to hold it all at once. One breath at a time." },
  { id: "growth", label: "I want to grow", symbol: "\u{1F331}", affirmation: "Every wound carries a wisdom waiting to be heard." },
  { id: "comfort", label: "I need comfort", symbol: "\u{1F49B}", affirmation: "You are not alone. You never were." },
  { id: "purpose", label: "Finding Purpose", symbol: "\u2b50", affirmation: "Your purpose is not lost. It is unfolding." },
];

export const ROTATING_SUBTEXTS = [
  "The cards don't judge. They only reflect.",
  "Whatever you're carrying, you don't have to carry it alone.",
  "You showed up today. That alone takes courage.",
  "The universe has been waiting for this question.",
  "Trust the whisper that brought you here.",
  "Some answers arrive before the question is fully formed.",
  "The truth is patient. It waits in the stillness.",
  "You are more ready than you think."
];
